import { render, staticRenderFns } from "./OnlineEventModule.vue?vue&type=template&id=1d800bd1&"
import script from "./OnlineEventModule.vue?vue&type=script&lang=js&"
export * from "./OnlineEventModule.vue?vue&type=script&lang=js&"
import style0 from "./OnlineEventModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports